import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  progress: {
    width: 'inherit',
  },
}));

export default useStyles;
